/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Latest status of the email sent
 */
export enum EmailSentEventStatusResponse {
    ATTEMPTED = 'Attempted',
    BOUNCED = 'Bounced',
    CLICKED = 'Clicked',
    CONVERTED = 'Converted',
    DELIVERED = 'Delivered',
    FAILED = 'Failed',
    OPENED = 'Opened',
    SENT = 'Sent',
    SPAM = 'Spam',
    SUPPRESSED = 'Suppressed',
    UNDELIVERED = 'Undelivered',
    UNSUBSCRIBED = 'Unsubscribed',
    UNKNOWN = 'Unknown',
}
